import { getIdentity } from "init/tracking";
import * as React from "react";
import version from "version";

export interface IDeviceID {
  deviceFingerprint: string;
  codeRevision: string;
}

export const DeviceIdContext = React.createContext<IDeviceID>({
  deviceFingerprint: "",
  codeRevision: version
});

interface IProps {
  className?: string;
  children: React.ReactNode;
}

interface IState {
  loading: boolean;
  deviceId: IDeviceID;
}

class DeviceIdCtxProvider extends React.Component<IProps, IState> {
  public constructor(props: IProps) {
    super(props);
    this.state = {
      loading: true,
      deviceId: { deviceFingerprint: "", codeRevision: version }
    };
  }

  public render() {
    const { className, children } = this.props;
    const { loading, deviceId } = this.state;

    return (
      <div className={className} title="DeviceIdCtxProvider">
        {!loading && (
          <DeviceIdContext.Provider value={deviceId}>
            {children}
          </DeviceIdContext.Provider>
        )}
      </div>
    );
  }

  public async componentDidMount() {
    const deviceFingerprint = await getIdentity();

    this.setState({
      loading: false,
      deviceId: { deviceFingerprint, codeRevision: version }
    });
  }
}

export default DeviceIdCtxProvider;



// WEBPACK FOOTER //
// ./src/components/Gates/DeviceIdCtxProvider.tsx